export const PROCESS_STARTED = 'PROCESS_STARTED'
export const PROCESS_COMPLETED = 'PROCESS_COMPLETED'
export const PROCESS_FAILED = 'PROCESS_FAILED'
export const CLEAR_PENDING = 'CLEAR_PENDING'
